import { createContext } from "react"

import { User } from "../../interfaces/user"

export const initialContext = {
    user: null as null | User,
    isLoading: false,
}
export const MyUserContext = createContext(initialContext)